<template>
  <b-sidebar
    right
    shadow
    v-model="show"
    backdrop
    class="sidebar-contents"
  >
    <div class="px-3">
      <div class="d-flex justify-content-between">
        <b-media vertical-align="center" class="d-flex justify-content-center align-items-center flex-wrap mb-1 col-6">
          <template #aside>
            <div class="container-avatar-table col-12">
              <b-avatar
                  size="lg"
                  :src="getImageInfluencer(content)"
                  :text="content.username[0]"
                  variant="light-primary"
                  badge-variant="ligth"
              >
              <template #badge>
                <b-avatar size="22px" class="avatar-absolute-sider">
                  <b-img :src="getIconWhite(content.network_influencer)" :class="getIconColor(content.network_influencer, false)" fluid/>
                </b-avatar>
              </template>
            </b-avatar>
            </div>
          </template>
          <div class="col-12">
            <a 
              class="d-block font-weight-bold h4 mb-0 col-12 text-center title-white-sidebar"
              :href="getURL(content.network_influencer, content.username, (content.network_influencer === 'youtube') ? true : false)"
              target="_blank"
            >
              {{ getUsername(content) }}
            </a>
          </div>
        </b-media>  
                
        <b-col class="d-flex flex-wrap justify-content-center col-6">
          <span class="d-block h5 col-12 text-center title-white-sidebar">{{getTypeInfluencer(content.category)}}</span>
          <span class="text-muted col-12 text-center">{{$t('campaigns.type_influencer')}}</span>

          <span class="d-block h5 col-12 text-center mt-2 title-white-sidebar">{{getLabelContentType(content)}}</span>
          <span class="text-muted d-block col-12 text-center">{{$t('briefcase_pricing.content_type')}}</span>
        </b-col>
      </div>
      <hr class="mb-1"/>

      <b-row>
        <b-col class="d-flex flex-wrap justify-content-center col-6 mb-2">
          <b-avatar rounded="lg" variant="light-primary">
            <feather-icon
            size="18"
            icon="LikeIcon"
            />
          </b-avatar>    
          <span class="d-block h5 col-12 text-center mt-1 title-white-sidebar">{{(content.followers)}}</span>
          <span class="text-muted d-block col-12 text-center">{{$t('campaigns.followers')}}</span>
        </b-col>

        <b-col class="d-flex flex-wrap justify-content-center col-6 mb-2">
          <b-avatar rounded="lg" variant="light-primary">
              <feather-icon
              size="18"
              icon="ActivityIcon"
              />
          </b-avatar>    
          <span class="d-block h5 col-12 text-center mt-1 title-white-sidebar">{{content.engagement}} %</span>
          <span class="text-muted d-block col-12 text-center">{{$t('campaigns.erTitle')}}</span>
        </b-col>
      </b-row>

      <hr class="mb-1"/>
      <h4 class="text-center">{{$t('campaigns.metrics_text')}}</h4>
      <div class="col-12 d-flex justify-content-center mt-2" v-if="isUrl(content.content_preview_url) && content.content_type !== 'story'">
        <b-avatar class="img-story" :src="content.content_preview_url">
          <template #badge>
            <b-avatar size="42px">
              <b-img :src="getIconWhite(content.network)" :class="getIconColor(content.network, false)" fluid/>
            </b-avatar>
          </template>
        </b-avatar>  
      </div>
      <general-form
        :content_dad="content"
        :uuids="{campaign_uuid, campaign_influencer}"
        :net="content.network"
        @closeModal="updateContent"
        :show_date_publish="true"
        :code_campaign="code_campaign"
      />
    </div>
  </b-sidebar>
</template>

<script>
import { BSidebar, BMedia, BAvatar, BCol, BRow, BImg, } from 'bootstrap-vue';
import GeneralForm from '@/views/pages/invitation/newInvitation/forms/GeneralForm.vue';
import { getIconWhite, getIconColor } from '@/libs/utils/icons'
import { getImageInfluencer, getTypeInfluencer } from '@/libs/utils/others';
import { isUrl, getURL } from '@/libs/utils/urls'

export default {
  name: 'sidebarContent',
  components: {
    GeneralForm,
    BSidebar,
    BMedia,
    BAvatar,
    BCol,
    BRow,
    BImg,
  },
  props: {
    content_dad: {
      type: Object,
      required: true
    },
    campaign_uuid: {
      type: String,
      required: true
    },
    campaign_influencer: {
      type: String,
      required: true
    },
    show_side: {
      type: Boolean,
      required: true
    },
    code_campaign: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      getTypeInfluencer,
      getURL,
      isUrl,
      getImageInfluencer,
      getIconWhite,
      getIconColor,
      show:  this.show_side,
      content: { ...this.content_dad}
    }
  },
  methods: {
    getLabelContentType(content) {
      if (content.network === 'tiktok' && content.content_type === 'reel') return this.$t(`invitation.videoVertical`)
      if (content.network === 'blog' && content.content_type === 'post') return 'Blog Post'
      if (content.network === 'snapchat' && content.content_type === 'reel') return 'Spotlight'
      return this.$t(`invitation.${content.content_type}`)
    },
    getUsername(influencer) {
      if (influencer.network_influencer === "youtube") return influencer.name;
      return influencer.username;
    },
    updateContent(data) {
      this.$emit('updateFromSidebar', data);
    }
  }
}
</script>

<style>
.avatar-absolute-sider {
  position: absolute;
  left:4px
}
.img-network{
  height: 35px !important;
  width: 35px !important;
  position: relative;
  bottom: -10em;
  right: 3em;
}
.sidebar-contents > .b-sidebar-backdrop {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.sidebar-contents > .b-sidebar {
  width: 500px !important;
}

</style>